import { IMAGE, IMAGE_MOBILE, BACKGROUND_IMAGE, BACKGROUND_IMAGE_MOBILE, ICON_FIELD } from '../elements/assets'
import { LINK_TITLE } from '../elements/link'

export const QUOTES_CAROUSEL = `
...on quotesCarousel_Entry {
  id
  typeHandle
  anchorId
  
  title
  heading: headingAdvanced { html }

  quotesCarouselContent {
    ... on quotesCarouselContent_Entry {
      id
      title

      heading: headingAdvanced { html }
      description

      quotesCarousel {
        ... on quotesCarouselSlide_Entry {
          id

          ${ ICON_FIELD }

          ${ IMAGE }
          ${ IMAGE_MOBILE }

          ${ BACKGROUND_IMAGE }
          ${ BACKGROUND_IMAGE_MOBILE }
          heading: headingAdvanced { html }
          quote
          authorName
          position

          ${ LINK_TITLE }

          textTable {
            heading
            text
          }

          comparisonTable {
            col1
            col2
          }
        }
      }

    }
  }

  tipsList {
    id
    title
    description
    iconField { url }
  }
}
`
